import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type EmptyLocation } from '../../domain/shipment/EmptyLocation'
import { ShipmentsRepository } from '../../infra/shipment/ShipmentsRepository'

export type GetEmptyLocationFactoryDependencies = {
  shipmentsRepository: ShipmentsRepository
}

export function getEmptyLocationFactory({
  shipmentsRepository,
}: GetEmptyLocationFactoryDependencies) {
  return async function getEmptyLocation(
    shipmentId: string,
    config?: {
      signal: AbortSignal
    }
  ): Promise<EmptyLocation> {
    return shipmentsRepository.getEmptyLocation(shipmentId, config)
  }
}

export function getEmptyLocation(
  shipmentId: string,
  config?: {
    signal: AbortSignal
  }
): Promise<EmptyLocation> {
  const httpClient = new HttpClient(API_URL)
  const shipmentsRepository = new ShipmentsRepository({ httpClient })
  const get = getEmptyLocationFactory({ shipmentsRepository })

  return get(shipmentId, config)
}
